import { z } from 'zod';

export const registerWithAccessLinkBodySchema = z.object({
  code: z.string(),
  password: z.string().min(8, 'Password must be at least 8 characters'),
});

export type RegisterWithAccessLinkInputDto = z.infer<typeof registerWithAccessLinkBodySchema>;
